// extracted by mini-css-extract-plugin
export default {"root":"Snackbar_root__VWQg1","info":"Snackbar_info__cK1bR","icon":"Snackbar_icon__jB-Cl","message":"Snackbar_message__KlCmi","closeIcon":"Snackbar_closeIcon__Q1800"};